import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Image } from 'react-native';

const GoogleButton = ({ title = 'Google', style, onPress, disabled }) => {
  return (
    <TouchableOpacity style={[styles.googleButton, disabled && styles.disabled, style]} onPress={disabled ? undefined : onPress} disabled={disabled}>
      <View style={styles.googleLogo}>
          <Image source={require('../assets/icons/google.png')} style={styles.googleLogoImage} />
      </View>
      <Text style={styles.googleButtonText}>{title}</Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  googleButton: {
    alignSelf: 'stretch',
    padding: 8,
    backgroundColor: '#000',
    borderRadius: 22,
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.16)',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    gap: 12,
    position: 'relative',
  },
  googleLogo: {
    width: 20,
    height: 20,
    position: 'relative',
    overflow: 'hidden',
  },
  googleLogoImage: {
    width: 20,
    height: 20,
  },
  googleColor: {
    position: 'absolute',
  },
  googleBlue: {
    width: 9.79,
    height: 9.37,
    left: 10.20,
    top: 8.15,
    backgroundColor: '#4285F4',
  },
  googleGreen: {
    width: 15.86,
    height: 7.99,
    left: 1.09,
    top: 11.94,
    backgroundColor: '#34A853',
  },
  googleYellow: {
    width: 4.40,
    height: 9,
    left: 0,
    top: 5.44,
    backgroundColor: '#FBBC05',
  },
  googleRed: {
    width: 15.93,
    height: 7.99,
    left: 1.09,
    top: 0,
    backgroundColor: '#EB4335',
  },
  googleButtonText: {
    textAlign: 'center',
    color: '#fff',
    fontSize: 15,
    fontFamily: 'Public Sans',
    fontWeight: '700',
    lineHeight: 20,
  },
  disabled: {
    opacity: 0.6,
  },
});

export default GoogleButton;


